import React from 'react'
import styles from './Skeleton.module.scss'

/**
 * Универсальный skeleton-loader для индикации загрузки.
 *
 * Варианты:
 *  - <Skeleton variant="text" lines={3} />
 *  - <Skeleton variant="circle" size={48} />
 *  - <Skeleton variant="rect" width="100%" height={120} />
 *  - <Skeleton variant="card" />  // композитный (avatar + 2 строки)
 *  - <Skeleton variant="table" rows={5} cols={4} />
 */
const Skeleton = ({
  variant = 'text',
  lines = 1,
  rows = 4,
  cols = 4,
  width,
  height,
  size = 40,
  className = '',
  style = {},
}) => {
  if (variant === 'circle') {
    return <div className={`${styles.skel} ${styles.circle} ${className}`} style={{ width: size, height: size, ...style }} aria-hidden="true" />
  }
  if (variant === 'rect') {
    return <div className={`${styles.skel} ${styles.rect} ${className}`} style={{ width, height, ...style }} aria-hidden="true" />
  }
  if (variant === 'card') {
    return (
      <div className={`${styles.card} ${className}`} aria-hidden="true">
        <div className={`${styles.skel} ${styles.circle}`} style={{ width: 48, height: 48 }} />
        <div className={styles.cardBody}>
          <div className={`${styles.skel} ${styles.line} ${styles.lineLong}`} />
          <div className={`${styles.skel} ${styles.line} ${styles.lineMedium}`} />
        </div>
      </div>
    )
  }
  if (variant === 'table') {
    return (
      <div className={`${styles.tableWrap} ${className}`} aria-hidden="true">
        {Array.from({ length: rows }).map((_, r) => (
          <div key={r} className={styles.tableRow}>
            {Array.from({ length: cols }).map((_, c) => (
              <div key={c} className={`${styles.skel} ${styles.line}`} style={{ flex: 1 }} />
            ))}
          </div>
        ))}
      </div>
    )
  }
  // default: text lines
  return (
    <div className={className} aria-hidden="true">
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className={`${styles.skel} ${styles.line} ${i === lines - 1 && lines > 1 ? styles.lineMedium : styles.lineLong}`}
        />
      ))}
    </div>
  )
}

export default Skeleton
